import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const qrcodeRegionId = "html5qr-code-full-region";

const QrCodeScanner = ({ onScanSuccess, onScanFailure }) => {
    const html5QrcodeRef = useRef(null);

    useEffect(() => {
        html5QrcodeRef.current = new Html5Qrcode(qrcodeRegionId, false);
        const html5Qrcode = html5QrcodeRef.current;

        const startScanner = async () => {
            try {
                await html5Qrcode.start(
                    { facingMode: "environment" },
                    { fps: 10, qrbox: { width: 250, height: 250 } },
                    (decodedText) => {
                        if (html5Qrcode.isScanning) {
                            html5Qrcode.stop().then(() => {
                                onScanSuccess(decodedText);
                            }).catch(err => console.error("Failed to stop scanner after scan.", err));
                        }
                    },
                    (errorMessage) => {
                        // onScanFailure(errorMessage);
                    }
                );
            } catch (err) {
                console.error("Unable to start QR scanner", err);
            }
        };

        startScanner();

        return () => {
            if (html5Qrcode && html5Qrcode.isScanning) {
                html5Qrcode.stop().catch(err => {
                    console.warn("Error stopping the scanner on unmount.", err);
                });
            }
        };
    }, [onScanSuccess, onScanFailure]);

    return <div id={qrcodeRegionId} />;
};

export default QrCodeScanner;
